const ANONYMOUS = 'Anonymous';
const UNIDENTIFIED = 'unidentified';
const FALLBACK_KEY_PREFIX = '__fallback__:';

export const toUsableIdentityAccountId = (value?: string | null): string | undefined => {
	if (!value) {
		return undefined;
	}
	if (value === ANONYMOUS || value === UNIDENTIFIED) {
		return undefined;
	}
	if (value.startsWith('ari:') || value.startsWith(FALLBACK_KEY_PREFIX)) {
		return undefined;
	}
	return value;
};
